import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import PaymentLinkTable from "../../payment-link-system/PaymentLinkTable";
import { formatDateTime, formatDateTimezon } from "../../common-data/Converts";
import TableSkeleton from "../../common-components/TableSkeleton";

const PreSaleGymLeadsListings = ({
  isPage,
  setIsPage,
  pageLimit,
  setPageLimit,
  setModValues,
}) => {
  const { preSaleGymLeads, preSaleGymLeadsLoading, preSaleGymLeadsError } =
    useSelector((state) => state.prospects);

  const iniLeadsDatas = {
    data: [],
    pagination: [],
  };
  const [leadsDatas, setLeadsDatas] = useState(iniLeadsDatas);

  useEffect(() => {
    if (
      !preSaleGymLeadsLoading &&
      !preSaleGymLeadsError &&
      preSaleGymLeads?.status &&
      preSaleGymLeads?.data
    ) {
      setLeadsDatas((prev) => ({
        ...prev,
        data: preSaleGymLeads.data,
        pagination: preSaleGymLeads?.pagination,
      }));
    } else {
      setLeadsDatas(iniLeadsDatas);
    }
  }, [preSaleGymLeadsLoading, preSaleGymLeadsError, preSaleGymLeads]);

  const tbColumns = [
    {
      dataField: "added_to_lead",
      text: "Action",
      formatter: (_, row) => (
        <div className="actionButtonContainer">
          {row?.added_to_lead ? (
            <button
              type="button"
              className="actionBtn"
              style={{
                minWidth: "120px",
                background: "#000",
                color: "#fff",
                borderRadius: "8px",
                cursor: "pointer",
                fontSize: "15px",
                padding: "10px",
              }}
              onClick={() =>
                setModValues((prevs) => ({
                  ...prevs,
                  isModOpen: true,
                  rowData: row,
                  modName: "view-lead-journey",
                  from: "pre-sale-gym-leads",
                }))
              }
            >
              View Lead
            </button>
          ) : (
            <button
              type="button"
              className="actionBtn"
              style={{
                minWidth: "120px",
                background: "#C90808",
                color: "#fff",
                borderRadius: "8px",
                cursor: "pointer",
                fontSize: "15px",
                padding: "10px",
              }}
              onClick={() =>
                setModValues((prevs) => ({
                  ...prevs,
                  isModOpen: true,
                  rowData: row,
                  modName: "add-to-lead",
                  from: "pre-sale-gym-leads",
                }))
              }
            >
              Add To LMS
            </button>
          )}
        </div>
      ),
    },
    {
      dataField: "uid",
      text: "Member Info",
      formatter: (_, row) => {
        return (
          <span className="tb-data underline">
            {row?.name || row?.full_name || "NA"}
            <br />
            <small className="lowercase">
              {row?.mobile || row?.phone_number || ""}
              <br />
              {row?.email || ""}
            </small>
          </span>
        );
      },
    },
    {
      dataField: "gym_name",
      text: "Gym",
      formatter: (_, row) => {
        return (
          <span className="tb-data minWidth150">{row?.gym_name || "NA"}</span>
        );
      },
    },
    {
      dataField: "preferred_location",
      text: "Preferred Location",
      formatter: (_, row) => {
        return (
          <span className="tb-data">{row?.preferred_location || "NA"}</span>
        );
      },
    },
    {
      dataField: "lead_status",
      text: "Lead Status",
      formatter: (_, row) => {
        const isNotLeadStatus = !row?.lead_status;

        return (
          <span
            className={`tb-data ${
              isNotLeadStatus ? "" : "minWidth100 withPadding borderRdius27"
            }`}
            style={{
              background: isNotLeadStatus
                ? ""
                : row?.lead_status === "converted"
                ? "#379C00"
                : row?.lead_status === "pending"
                ? "#EB8317"
                : !row?.lead_status
                ? "gray"
                : "#D90000",
              color: isNotLeadStatus ? "" : "#fff",
            }}
          >
            {row?.lead_status || "NA"}
          </span>
        );
      },
    },
    {
      dataField: "added_on_lead",
      text: "Added to LMS",
      formatter: (_, row) => {
        return (
          <span className="tb-data minWidth100">
            {row?.added_on_lead ? formatDateTimezon(row.added_on_lead) : "-"}
          </span>
        );
      },
    },
    {
      dataField: "assigned_to",
      text: "Assigned To",
      formatter: (_, row) => {
        return (
          <span className="tb-data underline">
            {row?.assigned_to_name || "NA"}
            <br />
            <small className="lowercase">
              {row?.assigned_to_mobile || ""}
              <br />
              {row?.assigned_to_email || ""}
            </small>
          </span>
        );
      },
    },
    {
      dataField: "date_added",
      text: "Date Added",
      formatter: (_, row) => {
        return (
          <span className="tb-data minWidth100">
            {row?.date_added ? formatDateTime(row.date_added) : "-"}
          </span>
        );
      },
    },
    // {
    //   dataField: "status",
    //   text: "Pre Sale Form Status",
    //   formatter: (_, row) => {
    //     const isActive = row?.status === "active";

    //     return (
    //       <span
    //         className="tb-data minWidth100 withPadding borderRdius27"
    //         style={{
    //           background: isActive ? "#379C00" : "#D90000",
    //           color: "#fff",
    //         }}
    //       >
    //         {row?.status || "NA"}
    //       </span>
    //     );
    //   },
    // },
  ];

  return (
    <>
      <div className="fullWidthFlexCenter overflowAuto separatedTable no-border-table">
        {preSaleGymLeadsLoading ? (
          <TableSkeleton
            columns={tbColumns.length || 10}
            rows={pageLimit * 2}
          />
        ) : (
          <PaymentLinkTable
            tableData={leadsDatas.data}
            tableColumns={tbColumns}
            tablePagination={leadsDatas.pagination}
            isPage={isPage}
            setIsPage={(value) => setIsPage(value)}
            pageLimit={pageLimit}
            setPageLimit={setPageLimit}
          />
        )}
      </div>
    </>
  );
};

export default PreSaleGymLeadsListings;
